import { addValidator } from 'redux-form-validators';

export const REG_EMAIL =
  // eslint-disable-next-line no-useless-escape
  /^[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@((?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)$/i;

const expressionEmails = (value) => {
  return (
    value
      .replace(/\s+/g, '')
      .split(',')
      .filter((emailString) => !emailString.match(REG_EMAIL)).length === 0
  );
};

const defaultMessageEmails = 'has invalid email(s) format';

export const emailsStringValidator = addValidator({
  defaultMessage: defaultMessageEmails,
  validator(_options, value) {
    return expressionEmails(value);
  },
});

export const emailsWithEmptyValidator = addValidator({
  defaultMessage: defaultMessageEmails,
  validator(_options, value) {
    if (value === '') return true;
    return expressionEmails(value);
  },
});
